import { AppEventEmitterDecorator } from "./AppEventEmitterDecorator";

export class ConcreteAppEventEmitter extends AppEventEmitterDecorator(class {}) {
    
}